import styles from "./ProgressIndicator.css";

interface ProgressIndicatorProps {
  totalSteps: number;
  currentStep: number;
  status?: "inProgress" | "completed";
  ariaLabel: string;
}

const ProgressIndicator = ({
  totalSteps,
  currentStep,
  status = "inProgress",
  ariaLabel,
}: ProgressIndicatorProps) => {
  const clampedStep = Math.min(Math.max(currentStep, 1), totalSteps);

  const getState = (index: number) => {
    if (status === "completed") {
      return "success";
    }
    return index < clampedStep ? "active" : "inactive";
  };

  return (
    <div
      className={styles.container}
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={status === "completed" ? totalSteps : clampedStep}
    >
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className={styles.segment({ state: getState(index) })}
        />
      ))}
    </div>
  );
};

export default ProgressIndicator;
